import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v0/basket-items';


class BasketItemEndpoint extends BaseEndpoint {
    list(params = null) {
        if (typeof params == 'string') {
            return this.client.$get(apiPath + params)
        } else {
            return this.client.$get(apiPath, {params: params})
        }
    }

    detail(id, params = null) {
        return this.client.$get(apiPath + '/' + id, {params: params}).catch(err => {
            console.log('Unsuccessful response: ', err);
        })
    }

    update_more(fields) {
        return this.client.$post(`${apiPath}/update_more`, fields);
    }

    update_buchung(fields) {
        return this.client.$post(`${apiPath}/update_buchung`, fields);
    }

    update(id, fields) {
        if (typeof fields.append !== 'undefined') {
            fields.append('_method', 'PUT')
        } else {
            fields._method = 'PUT'
        }
        return this.client.$post(`${apiPath}/${id}`, fields);
    }

    update_state(fields) {
        fields.data._method = 'PUT'
        return this.client.$post(apiPath + '/' + fields.id, fields.data)
    }

}

export default BasketItemEndpoint;
